"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var operators_1 = require("rxjs/operators");
var noop_1 = require("rxjs/util/noop");
var utilities_1 = require("../utilities");
var lodash_1 = require("lodash");
var logger = utilities_1.createLogger('sisCatch');
var SisCatchPipe = /** @class */ (function () {
    function SisCatchPipe() {
    }
    SisCatchPipe.prototype.transform = function (value$) {
        if (lodash_1.isNil(value$)) {
            return value$;
        }
        return value$.pipe(operators_1.tap(noop_1.noop, function (err) { return logger.error('caught following error %s', err); }));
    };
    SisCatchPipe = __decorate([
        core_1.Pipe({
            name: 'sisCatch',
        })
    ], SisCatchPipe);
    return SisCatchPipe;
}());
exports.SisCatchPipe = SisCatchPipe;
//# sourceMappingURL=sis-catch.pipe.js.map